import { useUserDetailCardQuery } from 'generated/graphql';
import { DateTime } from 'luxon';
import React from 'react';

export interface IData {
  id: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  preferredEmail: string;
  createdDate: string;
}

export function useQuery(id: string) {
  const tuple = useUserDetailCardQuery({
    variables: {
      id
    },
    skip: id === ''
  });

  return React.useMemo(
    () => {
      const data: IData = {
        id: tuple.data?.person?.id ?? '',
        firstName: tuple.data?.person?.firstName ?? '',
        lastName: tuple.data?.person?.lastName ?? '',
        phoneNumber: tuple.data?.person?.phoneNumber ?? '',
        preferredEmail: tuple.data?.person?.preferredEmail ?? '',
        createdDate: tuple.data?.person?.createdTimestamp.toFormat('DDDD') ?? DateTime.now().toFormat('DDDD')
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
